<template>
  <user-personal-data-form />
</template>

<script>
import UserPersonalDataForm from "../../../../components/Settings/Users/UserPersonalDataForm";
export default {
  name: "SettingsUserEditBasic",
  components: { UserPersonalDataForm }
};
</script>

<style scoped></style>
